module.exports = __webpack_public_path__ + "static/img/nonelist.3f6562a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nonelist.png
// module id = 6EiN
// module chunks = 1